import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.45.403A2 2 0 0 1 16 2.326V4h2a2 2 0 0 1 2 2v6.268A2 2 0 0 0 19 12a2 2 0 0 0-1 .268V9h-2v5.246a2 2 0 0 1-1.45 1.923L8.14 18h4.128A2 2 0 0 0 12 19c0 .364.097.706.268 1H1a1 1 0 0 1-1-1V5.754a2 2 0 0 1 1.45-1.923zM16 6v1h2V6zM2 17.674V5.754l12-3.428v11.92zM11 7a1 1 0 0 1 1 1v.05a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m8 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }